/**
 * Convert a timestamp string to a readable format (date and time only).
 * @param timestampString The timestamp string to convert.
 * @returns A formatted date string in a readable format (date and time only).
 */
export function formatTimestamp(timestampString: string): string {
    const timestamp = new Date(timestampString);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
    };
    return timestamp.toLocaleDateString(undefined, options);
  }
  